// extracted by mini-css-extract-plugin
module.exports = {"cta":"color-contrast-styles-module--cta--3ldnD"};